import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  defaultValue?: string;
  size?: "sm" | "lg";
  placeholder?: string;
  className?: string;
  onSubmitted?: () => void;
};

export default function SearchBar({
  defaultValue = "",
  size = "sm",
  placeholder = "搜索网站、分类或关键词",
  className = "",
  onSubmitted,
}: Props) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = value.trim();
    if (onSubmitted) onSubmitted();
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const isLarge = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 ${
        isLarge ? "h-14 pl-5 pr-2" : "h-10 pl-4 pr-1.5"
      } ${className}`}
    >
      <i className={`ri-search-line text-foreground-500 ${isLarge ? "text-lg" : "text-base"}`}></i>
      <input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索网站"
        className={`min-w-0 flex-1 bg-transparent text-foreground-900 outline-none placeholder:text-foreground-400 ${
          isLarge ? "text-base" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
          isLarge ? "h-10 px-6 text-sm" : "h-7 px-4 text-xs"
        }`}
      >
        搜索
      </button>
    </form>
  );
}